<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
}

html,
body {
    height: 100%;
}

body {
    overflow-y: auto;
    margin: 0;
}

html {
    background-image: url("../public/bg.png");
    background-size: cover;
    overflow: hidden;
}


@media screen and (min-width: 320px) {
    html {
        font-size: 14px;
    }
}

@media screen and (min-width: 1000px) {
    html {
        font-size: 16px;
    }
}
</style>
